import { useState } from "react";
import { useLocale } from "@/shared/i18n/LocaleContext";
import { TestimonialVideo } from "./TestimonialVideo";
import styles from "./TestimonialCarousel.module.css";

/* Figma usa o chevron do Material Symbols (24dp, wght 400) */
function Chevron() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M9.4 18 8 16.6 12.6 12 8 7.4 9.4 6l6 6z" />
    </svg>
  );
}

export function TestimonialCarousel() {
  const { content, locale } = useLocale();
  const isEn = locale === "en";
  const testimonials = content.testimonials;
  const items = testimonials.items;
  const [activeIndex, setActiveIndex] = useState(0);
  const active = items[activeIndex];

  function goTo(index: number) {
    const total = items.length;
    setActiveIndex(((index % total) + total) % total);
  }

  return (
    <section
      id="depoimentos"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="testimonials-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="testimonials-title" className={styles.srOnly}>
          {testimonials.title}
        </h2>

        <div className={styles.stage}>
          <button
            type="button"
            className={styles.navPrev}
            aria-label={isEn ? "Previous testimonial" : "Depoimento anterior"}
            onClick={() => goTo(activeIndex - 1)}
          >
            <Chevron />
          </button>

          <article className={styles.card} aria-live="polite">
            <TestimonialVideo
              key={active.youtubeId}
              className={styles.photo}
              videoId={active.youtubeId}
              title={isEn ? `Testimonial from ${active.name}` : `Depoimento de ${active.name}`}
            />
            <div className={styles.copy}>
              <img
                className={styles.icon}
                src={testimonials.icon}
                alt=""
                width={88}
                height={88}
                loading="lazy"
              />
              <div className={styles.identity}>
                <p className={styles.name}>{active.name}</p>
                <p className={styles.company}>{active.company}</p>
              </div>
              <blockquote className={styles.quote}>{active.quote}</blockquote>
            </div>
          </article>

          <button
            type="button"
            className={styles.navNext}
            aria-label={isEn ? "Next testimonial" : "Próximo depoimento"}
            onClick={() => goTo(activeIndex + 1)}
          >
            <Chevron />
          </button>
        </div>

        <div className={styles.dots} role="tablist" aria-label={isEn ? "Testimonials" : "Depoimentos"}>
          {items.map((item, index) => (
            <button
              key={item.name}
              type="button"
              role="tab"
              aria-selected={index === activeIndex}
              aria-label={
                isEn
                  ? `Go to testimonial from ${item.name}`
                  : `Ir para depoimento de ${item.name}`
              }
              className={index === activeIndex ? styles.dotActive : styles.dot}
              onClick={() => goTo(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
